import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
  root: {},
  button: {
    padding: '10px 45px',
    borderRadius: 20,
    textTransform: 'none',
    minWidth: 210,
    display: 'flex',
    justifyContent: 'space-between',
  },
  buttonGroup: {
    padding: 0,
    borderRadius: 20,
    background: 'Transparent',
    boxShadow: 'none',
  },

  downArrowIcon: {
    color: theme.palette.grey['600'],
  },

  overlay: {
    zIndex: 9999,
  },

  menu: {
    zIndex: 9999,
    background: theme.palette.background.paper,
    marginTop: 5,
    width: 217,
    boxShadow: '0px 1px 14px #00000014',
    border: `1px solid ${theme.palette.grey[800]}`,
    borderRadius: 10,
    paddingLeft: 13,
    paddingRight: 13,
    paddingBottom: 10,
  },
  menuItem: {
    zIndex: 9999,
    fontSize: 15,
    paddingBottom: 4,
    paddingTop: 4,
  },
}));
